import * as yup from 'yup';

export const schema = yup.object().shape({
  policyYear: yup.string().required('required'),
  insuranceProvider: yup.string().required('required'),
  currency: yup.string().required('required'),
  insuranceDeductiblesAmount: yup.string().required('required'),
});
